// Your web app's Firebase configuration
const firebase = {
    apiKey: "AIzaSyD_Rg3xWxLRKWXWGcudw94YrVSXF5lyWg8",
    authDomain: "codesnippet-85653.firebaseapp.com",
    projectId: "codesnippet-85653",
    storageBucket: "codesnippet-85653.appspot.com",
    messagingSenderId: "63014747322",
    appId: "1:63014747322:web:a525bfed8b57ca41549683"
  };

export { firebase }